<template>
    <div :class="appTheme">
        <div id="app">
            <router-view/>
        </div>
        <notifications-popup></notifications-popup>
        <transition name="slide-fade">
            <toast-message 
                v-if="toastMessage != null"
                :type="toastMessage.type"
                :title="__('title', toastMessage)" 
                :description="__('description', toastMessage)"
                @hideToast="$store.commit('setToastMessage', null)">
            </toast-message>
        </transition>
        <offline-modal v-if="!isOnline"></offline-modal>
    </div>
</template>

<script>
import Session from "@/utils/Session";
import ToastMessage from "@/components/global/ToastMessage";
import NotificationsPopup from "@/components/popups/NotificationsPopup";
import OfflineModal from "@/components/global/OfflineModal";

export default {
    components: {
        ToastMessage,
        NotificationsPopup,
        OfflineModal
    },
    data() {
        return {
            status: "loading",
            recentAndMostViewedAppsPollingInterval: null,
            recentAndMostViewedAppsPollingIntervalTimeout: 10 * 60000, // in milliseconds
            oldLanguage: null,
        }
    },
    mounted() {
        this.bindInstantTranslate();
        this.getUserPreference();
    },
    destroyed() {
        this.stopRecentAndMostViewedAppsPolling();
        this.unbindInstantTranslate();
    },
    methods: {
        getUserPreference() {
            let session = new Session();
            if(session.exists() && this.isUserPreferenceEnabled) {
                this.$store.dispatch("userPreferences/fetchRecentAndMostViewedApps");
                this.startRecentAndMostViewedAppsPolling();
            }
        },
        startRecentAndMostViewedAppsPolling() {
            this.recentAndMostViewedAppsInterval = setInterval(() => {
                this.$store.dispatch("userPreferences/fetchRecentAndMostViewedAppsWithoutLoading");
            }, this.recentAndMostViewedAppsPollingIntervalTimeout);
        },
        stopRecentAndMostViewedAppsPolling() {
            this.recentAndMostViewedAppsPollingInterval = null;
        },
        bindInstantTranslate() {
            document.onkeydown = (e) => {
                let keyCode = e.keyCode === undefined ? e.key : e.keyCode;
                switch(keyCode) {
                    case 18: // Alt Key
                        this.showTranslations();
                        break;
                }
            }
        },
        unbindInstantTranslate() {
            document.onkeydown = null;
            document.onkeyup = null;
        },
        showTranslations() {
            this.oldLanguage = this.currentLanguage;
            let newLanguage = this.oldLanguage === "en" ? "ar" : "en";
            this.$store.dispatch("setLanguage", newLanguage);
        },
        hideTranslations() {
            this.$store.dispatch("setLanguage", this.oldLanguage || "en");
        }
    },
    computed: {
        toastMessage() {
            return this.$store.getters.toastMessage;
        },
        currentLanguage() {
            return this.$store.getters.appLanguage;
        },
        isUserPreferenceEnabled() {
            return !!(this.$route.meta
                && this.$route.meta.userPreference
                && this.$route.meta.userPreference === true);
        },
        appTheme() {
            return this.$store.getters.appTheme;
        },
        isOnline() {
            return this.$root.isOnline;
        }
    },
    watch: {
        isUserPreferenceEnabled() {
            if(this.isUserPreferenceEnabled)
                this.getUserPreference();
        },
        isOnline(newVal, oldVal) {
            if(!oldVal && newVal)
                location.reload();
        }
    }
}
</script>

<style lang="scss">
body {
    box-sizing: border-box;
}
</style>
